export default {
  name: 'fr',
  data: {
    modal: {
      cancel: 'Annuler',
      confirm: 'OK'
    },
    pagination: {
      prev: 'Précédente',
      next: 'Suivante'
    },
    select: {
      empty: 'Aucune Donnée... \\[ o_x ]/'
    },
    table: {
      empty: 'Aucune Donnée... \\[ o_x ]/'
    }
  }
}